//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"NurbAngleTolerance",1,0],[0,"NurbFitTolerance",1,0],[0,"NurbJoinSegments",1,0],[0,"OutputType",1,0],[0,"SplineArcOutputType",1,0],[0,"SplineFitTolerance",1,0],[0,"SplineFitToleranceType",1,0],[0,"SplineLineOutputType",1,0]],[],[]];
SPLM.CAM.ArcOutputTypeCiBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ArcOutputTypeCiBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ArcOutputTypeCiBuilder.OutputTypes = Object.freeze({
    "LinearOnly" : "LinearOnly", "CirPerpToTaxis" : "CirPerpToTaxis", "CirPerpParallelToTaxis" : "CirPerpParallelToTaxis", "Nurbs" : "Nurbs", "Spline" : "Spline", "Cylindrical4x" : "Cylindrical4x"});

SPLM.CAM.ArcOutputTypeCiBuilder.SplineFitToleranceTypes = Object.freeze({
    "Percent" : "Percent", "Value" : "Value"});

SPLM.CAM.ArcOutputTypeCiBuilder.SplineLineOutputTypes = Object.freeze({
    "Spline" : "Spline", "Line" : "Line"});

SPLM.CAM.ArcOutputTypeCiBuilder.SplineArcOutputTypes = Object.freeze({
    "Spline" : "Spline", "ArcPerpToTaxis" : "ArcPerpToTaxis", "ArcPerpParallelToTaxis" : "ArcPerpParallelToTaxis"});

export default SPLM;